import ApiClient from '@afosto/api/ApiClient';

class Calculations {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Invoice calculation
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Creates the invoice
   * @returns {Promise}
   */
  createInvoiceForCalculation(id, body, options = {}) {
    return this.apiClient.request({
      url: `/odr/calculations/${id}/invoices`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Get calculation
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Returns a calculation
   * @returns {Promise}
   */
  getCalculation(id, options = {}) {
    return this.apiClient.request({
      url: `/odr/calculations/${id}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * List calculations
   *
   * @param {Object} options - The additional request options
   * @description Returns a list of calculations
   * @returns {Promise}
   */
  listCalculations(options = {}) {
    return this.apiClient.request({
      url: `/odr/calculations`,
      method: 'get',
      ...options,
    });
  }
}

export const calculations = new Calculations();

export default Calculations;
